// extracted by mini-css-extract-plugin
export default {"image":"SomaAtNight_image__UM+UC","image-container":"SomaAtNight_image-container__rmCKU"};